import { QueryClient } from '@tanstack/react-query'
import type { ApiError } from '@/types'

// Don't retry on authentication errors
const shouldRetry = (failureCount: number, error: unknown): boolean => {
  const apiError = error as ApiError
  // Don't retry on 401 (unauthorized) or 403 (forbidden)
  if (apiError?.status === 401 || apiError?.status === 403) {
    return false
  }
  // Retry once for other errors
  return failureCount < 1
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: shouldRetry,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
})
